

























import {Component, Vue} from 'vue-property-decorator';
import HeaderMenu from './HeaderMenu.vue';
import HeaderButtons from './HeaderButtons.vue';
import MobileMenu from './HeaderMobileMenu.vue';
import {mapGetters} from "vuex";
import Search from "./Search.vue";

@Component({
    components: {HeaderMenu, HeaderButtons,  MobileMenu, Search},
    computed: {
        ...mapGetters({
            'info': 'info/info',
            'showAdmin': 'settings/showAdminButton'
        })
    }
})

export default class HeaderCOMUNE extends Vue {
    private showAdmin!: any;

    get search() {
        return this.$store.getters['group/search']
    }

    set search(val: string) {
        this.$store.dispatch('group/search', {s: val})
    }

    get whoIs() {
        return this.$store.getters['me/me'];
    }

    get someoneIsLogged() {
        return this.$store.getters['me/someoneIsLogged'];
    }

    public logout() {
        const locale = this.$i18n.locale;
        this.$store.dispatch('me/logout', {locale});
        this.$store.dispatch('group/reset');
        if (this.$route.name !== 'home') {
            this.$router.push({name: 'home'});
        }
        this.$store.dispatch('menu/setVisibility', {v: false});
    }

    get width() {
        if (this.showAdmin && this.someoneIsLogged) {
            return 'w-25'
        }
        return 'w-33'
    }

    get Icon() {
        return this.someoneIsLogged ? 'sign-out-alt' : 'user-lock';
    }

    get flag() {
        switch (this.$i18n.locale) {
            case 'en':
                return 'it';
            case 'it':
                return 'gb';
        }
    }

    public mounted() {
        this.$store.dispatch('me/fetchWhoAmI',{locale:this.$i18n.locale});
    }
}
